module.exports = __webpack_public_path__ + "img/spinner.5558212d.svg";